define("calendar/controllers/media", ["exports", "@ember/controller", "@ember/object", "@ember/service", "@glimmer/tracking", "ember-concurrency", "ember-concurrency-ts", "later/utils/calendar/constants", "later/utils/constants", "later/utils/constants/segment-events", "later/utils/focus"], function (_exports, _controller, _object, _service, _tracking, _emberConcurrency, _emberConcurrencyTs, _constants, _constants2, _segmentEvents, _focus) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15;

  0; //eaimeta@70e063a35619d71f0,"@ember/controller",0,"@ember/object",0,"@ember/service",0,"@glimmer/tracking",0,"ember-concurrency",0,"ember-concurrency-ts",0,"later/utils/calendar/constants",0,"later/utils/constants",0,"later/utils/constants/segment-events",0,"later/utils/focus"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  let MediaController = (_dec = (0, _object.computed)('model.{processing,isVideo,isGif,isImage,failed}', 'currentAccount.stopTheWorld', 'selectedSocialProfiles.profiles'), _dec2 = (0, _object.computed)('currentGroup.contributor', 'mediaItem.approved'), _dec3 = (0, _object.computed)('currentGroup.contributor', 'mediaItem.approved'), _dec4 = (0, _object.computed)('model.dirtyType'), _dec5 = (0, _object.computed)('model.labels.[]'), _dec6 = (0, _object.computed)('model.{processing,isVideo,isImage}', 'currentAccount.stopTheWorld', 'profiles'), (_class = class MediaController extends _controller.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "intl", _descriptor2, this);

      _initializerDefineProperty(this, "errors", _descriptor3, this);

      _initializerDefineProperty(this, "secondaryModal", _descriptor4, this);

      _initializerDefineProperty(this, "segment", _descriptor5, this);

      _initializerDefineProperty(this, "selectedSocialProfiles", _descriptor6, this);

      _initializerDefineProperty(this, "dialogManager", _descriptor7, this);

      _initializerDefineProperty(this, "router", _descriptor8, this);

      _initializerDefineProperty(this, "savedCaptionToEdit", _descriptor9, this);

      _initializerDefineProperty(this, "editingAltText", _descriptor10, this);

      _initializerDefineProperty(this, "editingCaption", _descriptor11, this);

      _initializerDefineProperty(this, "uniqueId", _descriptor12, this);

      _initializerDefineProperty(this, "location", _descriptor13, this);

      _initializerDefineProperty(this, "showComments", _descriptor14, this);

      _initializerDefineProperty(this, "viewDetail", _descriptor15, this);
    }

    get altTextCount() {
      return this.model.altText?.length ?? 0;
    }

    get canCreatePost() {
      if (!this.socialProfile) {
        return false;
      } else if (this.showUpgradeButton) {
        return false;
      } else if (this.model.processing && !this.model.isVideo) {
        return false;
      } else if (this.model.failed) {
        return false;
      } else if (this.model.isVideo && !this.socialProfile.canPostVideo) {
        return false;
      } else if (this.model.isGif && !this.socialProfile.canPostGif) {
        return false;
      } else if (this.socialProfile.isTiktok && this.model.isImage) {
        return false;
      } else if (this.socialProfile.isYoutube && this.model.isImage) {
        return false;
      } else if (this.currentAccount.stopTheWorld) {
        return false;
      }

      return true;
    }

    get canDestroyMedia() {
      return !(this.currentGroup.contributor && this.mediaItem.approved);
    }

    get canEditLabel() {
      return !this.currentGroup.contributor;
    }

    get createPostText() {
      const isPinterest = this.socialProfile?.get('isPinterest');
      return this.intl.t(isPinterest ? 'calendar.modal.pinterest.create_post' : 'calendar.modal.create_post');
    }

    get currentAccount() {
      return this.auth.currentAccount;
    }

    get currentGroup() {
      return this.auth.currentGroup;
    }

    get hasDirtyAttributes() {
      return this.model.get('dirtyType') === 'updated';
    }

    get hasLabels() {
      return Number(this.model.labels.length) > 0;
    }

    get hasSecondary() {
      return this.secondaryModal.isModalOpen();
    }

    get linkingSocialProfile() {
      return this.socialProfile || this.auth.currentSocialProfile;
    }

    get maxAltTextCount() {
      return _constants.ALT_TEXT_MAXIMUM_CHARACTERS;
    }

    get mediaItem() {
      return this.model;
    }

    get profiles() {
      return this.selectedSocialProfiles.profiles;
    }

    get rejectCreatePostReason() {
      if (!this.socialProfile?.hasPostsLeft) {
        return this.intl.t('media_items.update.max_posts');
      } else if (this.model.processing) {
        return this.intl.t('media_items.update.processing_post');
      } else if (this.model.failed) {
        return this.intl.t('media_items.update.failed_media');
      } else if (this.model.isVideo && !this.socialProfile.canPostVideo) {
        if (this.socialProfile.isLinkedin) {
          return this.intl.t('alerts.linkedin.errors.video_not_supported_message');
        }

        return this.intl.t('posts.modal.unsupported_video_platform.pinterest_message');
      } else if (this.model.isGif && !this.socialProfile.canPostGif) {
        return this.intl.t('posts.modal.unsupported_gif_platform', {
          platform: this.socialProfile.accountType
        });
      } else if (this.model.isImage && !this.socialProfile.canPostImage) {
        return this.intl.t('alerts.calendar.cant_schedule_image.message', {
          platform: this.socialProfile.localizedAccountType
        });
      } else if (this.currentAccount.stopTheWorld) {
        return this.intl.t('posts.modal.stop_the_world');
      }

      return '';
    }

    get showUpgradeButton() {
      return !this.socialProfile?.hasPostsLeft;
    }

    get socialProfile() {
      return this.selectedSocialProfiles.firstProfile;
    }

    cancelEditingCaption() {
      this.model.rollbackAttributes();
      this.editingCaption = false;
      this.secondaryModal.removeModal();
    }

    cancelEditingAltText() {
      this.model.rollbackAttributes();
      this.editingAltText = false;
      this.secondaryModal.removeModal();
    }

    editAltText() {
      this.editingAltText = true;
      (0, _focus.default)('#textareaAltText');
    }

    editCaption() {
      this.editingCaption = true;
      (0, _focus.default)('#textareaMediaNote');
    }

    editPost(post_id) {
      this.router.transitionTo('cluster.schedule.calendar.post.edit', post_id);
    }

    savedCaptionSegmentEvent(eventName, savedCaptionTitle) {
      this.segment.track(eventName, {
        group_id: this.currentGroup.id,
        location: 'media_item',
        saved_caption_title: savedCaptionTitle
      });
    }

    saveModelIfDirty() {
      if (this.hasDirtyAttributes) {
        // gets called when user hits "Create Post" and media item is in a dirty state --G
        this.model.save();
      }
    }

    toggleCaptionTemplate() {
      this.secondaryModal.toggleModal(this.uniqueId, _constants2.SECONDARY_MODAL_TYPES.SAVED_CAPTIONS);
    }

    toggleSecondary(type, location) {
      this.secondaryModal.toggleModal(this.uniqueId, type, location);
    }

    toggleSmartHashtags() {
      this.secondaryModal.toggleModal(this.uniqueId, _constants2.SECONDARY_MODAL_TYPES.SMART_HASHTAGS);
    }

    toggleCaptionWriter() {
      this.secondaryModal.toggleModal(this.uniqueId, _constants2.SECONDARY_MODAL_TYPES.CAPTION_WRITER);
    }

    toggleStarred() {
      if (this.mediaItem.isStarred) {
        this.send('removeStarred', this.mediaItem);
      } else {
        this.send('addStarred', this.mediaItem);
      }
    }

    updateMediaItem() {
      this.mediaItem.save().then(() => {
        this.send('closeModal');
      }).catch(adapterError => {
        this.errors.handleAdapter(adapterError, this.mediaItem);
      });
    }

    *_confirmUnsavedChanges() {
      const didConfirm = yield this.dialogManager.confirmation(this.intl.t('shared_phrases.close_warning'), {
        description: this.intl.t('shared_phrases.changes_not_saved'),
        confirmButton: this.intl.t('shared_words.leave')
      });

      if (!didConfirm) {
        return;
      }

      yield (0, _emberConcurrencyTs.taskFor)(this._rollbackModelAndClose).perform();
    }

    *_rollbackModelAndClose() {
      try {
        yield this.model.rollbackAttributes();
      } catch (adapterError) {
        this.errors.handleAdapter(adapterError);
      }

      this.send('closeModal');
    }

    *canClose() {
      if (this.hasDirtyAttributes || this.savedCaptionToEdit?.isNew || this.savedCaptionToEdit?.hasDirtyAttributes) {
        yield (0, _emberConcurrencyTs.taskFor)(this._confirmUnsavedChanges).perform();
      } else {
        yield (0, _emberConcurrencyTs.taskFor)(this._rollbackModelAndClose).perform();
      }
    }

    *rollbackSavedCaption() {
      try {
        if (this.savedCaptionToEdit?.isNew) {
          yield this.savedCaptionToEdit.deleteRecord();
        } else if (this.savedCaptionToEdit?.hasDirtyAttributes) {
          yield this.savedCaptionToEdit.rollbackAttributes();
        }

        this.set('savedCaptionToEdit', null);
      } catch (adapterError) {
        this.errors.handleAdapter(adapterError);
      }
    }

    *saveEditedCaption() {
      try {
        yield (0, _emberConcurrencyTs.taskFor)(this._saveTextField).perform('defaultCaption');
        this.segment.track('updated-media-notes', {
          group_id: this.currentGroup.id,
          media_id: this.model.id,
          media_url: this.model.isVideo ? this.model.videoUrl : this.model.imageUrl,
          notes: this.model.defaultCaption,
          location: this.location ? this.location : ''
        });
      } catch (adapterError) {
        this.errors.handleAdapter(adapterError, this.model);
        this.model.rollbackAttributes();
      }

      this.editingCaption = false;
      this.secondaryModal.removeModal();
    }

    *saveEditedAltText() {
      try {
        this.model.altText = this.model.altText?.trim();
        yield (0, _emberConcurrencyTs.taskFor)(this._saveTextField).perform('altText');
        this.segment.track(_segmentEvents.SegmentEventTypes.UpdatedMediaAltText, {
          alt_text: this.model.altText ?? _constants2.NULL_VALUE,
          group_id: this.currentGroup.id,
          media_id: this.model.id,
          media_url: this.model.isVideo ? this.model.videoUrl : this.model.imageUrl,
          notes: this.model.defaultCaption,
          location: this.location ?? ''
        });
      } catch (adapterError) {
        this.errors.handleAdapter(adapterError, this.model);
        this.model.rollbackAttributes();
      }

      this.editingAltText = false;
      this.secondaryModal.removeModal();
    }
    /**
     * Save the specified text field ONLY and not other text fields.
     *
     * TODO: This is really bad but unfortunately a necasary evil while
     * we continue with data-mapping our form fields directly to the model.
     * The purpose here is to save a single field EVEN IF the other fields
     * have been edited but not saved yet. We need to rework how we're mapping
     * our form fields to our models - probably need a separate state object.
     *
     * @param field Which field to save exclusively.
     */


    *_saveTextField(field) {
      const defaultCaption = this.model.get('defaultCaption');
      const altText = this.model.get('altText');
      this.model.rollbackAttributes();

      if (field === 'defaultCaption') {
        this.model.defaultCaption = defaultCaption;
        yield this.model.save();
        this.model.altText = altText;
      }

      if (field === 'altText') {
        this.model.altText = altText;
        yield this.model.save();
        this.model.defaultCaption = defaultCaption;
      }
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "secondaryModal", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "selectedSocialProfiles", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "savedCaptionToEdit", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "editingAltText", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "editingCaption", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "uniqueId", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "location", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "showComments", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return true;
    }
  }), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "viewDetail", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "canCreatePost", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "canCreatePost"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canDestroyMedia", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "canDestroyMedia"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canEditLabel", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "canEditLabel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasDirtyAttributes", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "hasDirtyAttributes"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasLabels", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "hasLabels"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "rejectCreatePostReason", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "rejectCreatePostReason"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cancelEditingCaption", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "cancelEditingCaption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cancelEditingAltText", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "cancelEditingAltText"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "editAltText", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "editAltText"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "editCaption", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "editCaption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "editPost", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "editPost"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "savedCaptionSegmentEvent", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "savedCaptionSegmentEvent"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "saveModelIfDirty", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "saveModelIfDirty"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleCaptionTemplate", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleCaptionTemplate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleSecondary", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleSecondary"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleSmartHashtags", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleSmartHashtags"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleCaptionWriter", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleCaptionWriter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleStarred", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleStarred"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateMediaItem", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateMediaItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_confirmUnsavedChanges", [_emberConcurrency.task], Object.getOwnPropertyDescriptor(_class.prototype, "_confirmUnsavedChanges"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_rollbackModelAndClose", [_emberConcurrency.task], Object.getOwnPropertyDescriptor(_class.prototype, "_rollbackModelAndClose"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canClose", [_emberConcurrency.task], Object.getOwnPropertyDescriptor(_class.prototype, "canClose"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "rollbackSavedCaption", [_emberConcurrency.task], Object.getOwnPropertyDescriptor(_class.prototype, "rollbackSavedCaption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "saveEditedCaption", [_emberConcurrency.task], Object.getOwnPropertyDescriptor(_class.prototype, "saveEditedCaption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "saveEditedAltText", [_emberConcurrency.task], Object.getOwnPropertyDescriptor(_class.prototype, "saveEditedAltText"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_saveTextField", [_emberConcurrency.task], Object.getOwnPropertyDescriptor(_class.prototype, "_saveTextField"), _class.prototype)), _class));
  _exports.default = MediaController;
});